import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import { addItem, selectLoading } from "./visitSlice";
import { useHistory } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  showDialog,
  useForceUpdate,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchCustomer, selectCustomer } from "../customer/customerSlice";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  useLoadScript,
} from "@react-google-maps/api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const libraries = ["places"];
const mapContainerStyle = { width: "100%", height: "600px" };
const center = { lat: -6.2088, lng: 106.8456 };

export const VisitCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataCustomer = useSelector(selectCustomer);

  const forceUpdate = useForceUpdate();

  const { SearchBar } = Search;

  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddres] = useState("");

  const [show, setShow] = useState("");
  const [listCustomer, setListCustomer] = useState([]);
  const [dataItem, setDataItem] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [points, setPoints] = useState([]);
  const [map, setMap] = useState(null);
  const [maps, setMaps] = useState(null);
  const [mapActive, setMapActive] = useState(true);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchCustomer({
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataCustomer !== null) {
      const initData = dataCustomer.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });
      setListCustomer(initData);
    }
  }, [dataCustomer]);

  const handleSave = async () => {
    const params = {
      company_name: name,
      contact_person: contact,
      phone: phoneNumber,
      address: address,
    };

    try {
      const response = await dispatch(addItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        await history.goBack();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const columnsCustomer = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "customer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "store name",
      dataField: "customer_store_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "kab kota",
      dataField: "customer_kab_kota",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "kecamatan",
      dataField: "customer_kecamatan",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "kelurahan",
      dataField: "customer_kelurahan",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "provinsi",
      dataField: "customer_provinsi",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "status",
      dataField: "customer_store_status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const onSelectRow = {
    mode: "checkbox",
    // clickToSelect: true,
    onSelectAll: (isSelect, rows) => {
      console.log(isSelect, "isSelect");
      console.log(rows, "rows");
      if (isSelect) {
        setSelectedRows(rows);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        if (
          points.filter(
            (e) =>
              e.customer_id === row.customer_id &&
              e.customer_code === row.customer_code
          ).length > 0
        ) {
          showDialog("Already selected");
          return false;
        }
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
      return true;
    },
  };

  const handleSubmit = () => {
    // Validation
    const result = selectedRows.filter(
      (elem) => !points.find(({ id }) => elem.id === id)
    );

    const initData = result.map((item) => {
      return {
        ...item,
        content: item.customer_code + "-" + item.customer_store_name,
        id: item.customer_id,
        lat: parseFloat(item.customer_latitude),
        lng: parseFloat(item.customer_longitude),
      };
    });

    setPoints((points) => [...points, ...initData]);
    setSelectedRows([]);
    handleClose();
    forceUpdate();
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_KEY,
    libraries,
  });
  const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);
  const [directions, setDirections] = useState(null);

  useEffect(() => {
    if (isLoaded && !loadError) setIsGoogleLoaded(true);
  }, [isLoaded, loadError]);

  useEffect(() => {
    if (!isGoogleLoaded || points.length < 2 || !window.google) return;

    const MAX_WAYPOINTS = 25;
    const totalChunks = Math.ceil((points.length - 2) / MAX_WAYPOINTS);

    let mergedDirections = []; // menampung semua segment hasil API

    const processChunk = (index) => {
      if (index >= totalChunks) {
        // selesai → set ke state kamu
        setDirections(mergedDirections);
        return;
      }

      const start = index * MAX_WAYPOINTS;
      const end = start + MAX_WAYPOINTS;
      const chunk = points.slice(start, end + 1);

      if (chunk.length < 2) {
        processChunk(index + 1);
        return;
      }

      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin: { lat: chunk[0].lat, lng: chunk[0].lng },
          destination: {
            lat: chunk[chunk.length - 1].lat,
            lng: chunk[chunk.length - 1].lng,
          },
          waypoints: chunk.slice(1, -1).map((p) => ({
            location: { lat: p.lat, lng: p.lng },
          })),
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === "OK") {
            mergedDirections.push(result);
          } else {
            console.error("Route error:", status);
          }

          processChunk(index + 1);
        }
      );
    };

    processChunk(0);
  }, [isGoogleLoaded, points]);

  const directionsCallback = (response) => {
    if (response !== null && response.status === "OK") setDirections(response);
    else console.log("directions response: ", response);
  };

  const data = [
    // { id: "1", content: "Item 1 jakpus", lat: -6.2088, lng: 106.8456, status: "Y" },
    // { id: "2", content: "Item 2 jaktim", lat: -6.2348, lng: 106.8886, status: "Y" },
    // { id: "3", content: "Item 3 bektim", lat: -6.2469, lng: 107.0065, status: "N" },
    // { id: "4", content: "Item 4 karawang", lat: -6.3084, lng: 107.235, status: "N" },
  ];

  // useEffect(() => {
  //   setPoints(
  //     data.map((point) => ({
  //       ...point,
  //       lat: parseFloat(point.lat),
  //       lng: parseFloat(point.lng),
  //     }))
  //   );
  // }, []);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(points);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setPoints(items);
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="Create Visit"></CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Customer <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" disabled />
                  </Col>
                  <Col sm={1}>
                    <div
                      className="btn btn-icon btn-light btn-hover-danger btn-sm"
                      onClick={() => setShow(true)}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                        />
                      </span>
                    </div>
                  </Col>
                </Form.Group>
                <div>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {points.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{
                                    userSelect: "none",
                                    padding: 16,
                                    margin: "0 0 8px 0",
                                    backgroundColor: "white",
                                    ...provided.draggableProps.style,
                                  }}
                                  className="draggable-item" // Tambahkan kelas CSS di sini
                                >
                                  <span>{item.content}</span>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                {isLoaded ? (
                  <GoogleMap
                    id="autocomplete-demo"
                    mapContainerStyle={mapContainerStyle}
                    zoom={8}
                    center={center}
                  >
                    {points.map((point) => (
                      <Marker
                        key={point.id}
                        position={{ lat: point.lat, lng: point.lng }}
                      />
                    ))}
                    {Array.isArray(directions) &&
                      directions.map((dir, i) => (
                        <DirectionsRenderer key={i} directions={dir} />
                      ))}
                  </GoogleMap>
                ) : (
                  <div>Loading...</div>
                )}
              </Col>
            </Form.Group>
          </Form>

          <Row className="justify-content-end mt-5">
            <Button
              variant="light"
              className="mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            <Button variant="danger" onClick={handleSave}>
              Save
            </Button>
          </Row>
        </CardBody>
      </Card>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="card-body pt-0   "
            style={{
              height: "650px",
              overflowY: "scroll",
            }}
          >
            <ToolkitProvider
              keyField="customer_id"
              data={listCustomer}
              columns={columnsCustomer}
              search
            >
              {(props) => (
                <div>
                  <Row>
                    <Col>
                      <h3>Customer</h3>
                    </Col>
                    <Col>
                      <div className="float-right">
                        <SearchBar
                          {...props.searchProps}
                          placeholder="Search .."
                        />
                      </div>
                    </Col>
                  </Row>

                  <hr />
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    bordered={true}
                    selectRow={onSelectRow}
                    {...props.baseProps}
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleSubmit}>
            Submit
          </Button>{" "}
        </Modal.Footer>
      </Modal>
    </>
  );
};
